import { Injectable } from '@angular/core';
import { IEnumCacheKeys } from '../../constants';

@Injectable({ providedIn: 'root' })
export class CacheService {
  get<T>(key: IEnumCacheKeys): T {
    const savedString: string = sessionStorage.getItem(key) || '';
    const res: T = savedString && JSON.parse(savedString);
    return res;
  }

  set<T>(key: IEnumCacheKeys, value: T | string): void {
    if (typeof (value) !== 'string') value = JSON.stringify(value);
    sessionStorage.setItem(key, value);
  }
}